import React, { useContext, useEffect } from 'react'
import imgIcon from "../../assets"
import { Buttons } from "../../common/Buttons"
import { Card, MarketplaceCard, HowWorkIcon, ServicePartnerCard } from '../../common/Card'
import "../Styles/home.css"
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import ExploreIcon from '@mui/icons-material/Explore';
import ShareIcon from '@mui/icons-material/Share';
import EmailIcon from '@mui/icons-material/Email';
import Header from '../../layout/header/header'
import { Footer } from '../../layout/Footer/Footer'
import { useNavigate } from "react-router-dom";
import redirecturls from '../../apis/Redirecturls'
import { Input } from "../Components/Input"
import { Model } from '../../common/Model'
import { useState } from 'react'
import Form from '../Components/Form'
import { useDispatch, useSelector } from 'react-redux'
import FormContextApi from '../../ContextApi'
import { getAllCities, getCityFromPincode } from '../../actions/user'



function Home() {

  const { serviceInit, setserviceInit, options } = useContext(FormContextApi)
  const [popup, setpopup] = useState(false)
  const navigate = useNavigate()
  const [form, setForm] = useState(serviceInit);

  const submit = (fo) => {
    if (fo?.pincode?.length === 6) {
      setserviceInit({ ...form, pincode: fo?.pincode })
    }
    navigate("/userdetails")
  }

  const clickHandler = (path) => {
    window.open(path, "_blank")
  }


  return (
    <>
      <Header />
      {popup && <Model setpopup={setpopup} />}
      <div>
        {/* Hero section */}
        <div className="mt-14 backCo" >
          <div className="mainImg pt-12">
            <div className='flex items-center'>
              <div className='w-3/5 p-5 mb-20 ml-8'>
                <div className="pl-10 pr-6" >
                  <div className='text-white' >
                    <h1 className="font-bold mb-2" style={{ fontSize: "2.8rem" }} > Book a <span className="text-scogoOrange" > Networking </span> Professional </h1>
                    <p className="text-lg mt-5 w-11/12" >Scogo Networks provide one-stop solution for country-wide technology <br /> delivery & sustenance.</p>
                  </div>
                  <Form
                    btnclass="w-36 rounded-r-lg font-medium h-20 text-white bg-scogoOrange"
                    btnText="Book Now"
                    btnposition="px-2 pb-0 pt-0"
                    setForm={setForm}
                    form={form}
                    formName="homepageservices"
                    submit={e => submit(e)}
                    formClass={"mt-6 flex bg-white rounded-lg items-center px-1 w-fit"}
                  >
                    <div className="flex items-center">
                      <div className="w-72 ml-2">
                        <Input type="dropdown" label="Service Type" options={options} labelClass="text-star-dust-500 text-sm" placeholder="Technical Support" />
                      </div>
                      <div className="w-36" >
                        <Input type="number" name="pincode" label="Pincode" className="mb-6" />
                      </div>
                    </div>

                  </Form>
                </div>
              </div>
              <div className="border border-transparent banner-container">
              </div>
            </div>
          </div>
          <div className="curve" >
            <img alt="" />
          </div>
        </div>
        {/* Use case section */}
        <div className="mt-24">
          <div className="homeFontHe text-center">
            <h1 className="text-5xl text-scogoOrange" >Use <span className="text-scogoprimary" >Cases</span> </h1>
          </div>

          <div className="mt-6 ">
            <div className='allCard p-5 mt-4 gird grid-cols-4 gap-x-8' >
              <Card img={imgIcon.Network} cardHeding="Network Solution" />
              <Card img={imgIcon.EndUserComputing} cardHeding="End User Computing" />
              <Card img={imgIcon.WorkplaceSecurity} cardHeding="Workplace Security & Automation " />
              <Card img={imgIcon.ElectricSolutions} cardHeding="Electric Vehicle Charging Solutions" />
              <Card img={imgIcon.Wifi} cardHeding="Wifi And Internet Service Provider" />
              <Card img={imgIcon.IndustrialIot} cardHeding="Iot And Industrial Iot Solutions" />
              <Card img={imgIcon.DataCenter} cardHeding="Data Center Field Support Services" />
              <Card img={imgIcon.Programmable} cardHeding="Programmable Field Services" />
            </div>
          </div>

        </div>


        {/* Grow your Business */}
        <div className=" growBusiness mt-24">
          <div className="flex p-4 m-auto items-center justify-center" >
            <div className="w-1/2 ">
              <div className="p-4 ">
                <img width="80%" className='m-auto' height="100%" src={imgIcon.GrowBusiness} alt="" />
              </div>
            </div>
            <div className="w-1/2 " >
              <div>
                <h1 className="font-bold text-scogoOrange text-5xl">Grow your Business.</h1>
                <h1 className="mt-2 font-bold text-scogoprimary text-5xl" >Extend your Service Territory.</h1>

                <p className=" mt-5 text-lg w-11/12">With an internet startup on a mission to disrupt the Billion Dollar service <br /> industry in India with its globally unique and unmatched business model.<br /> On a bandwagon to transform the entire service industry through our <br /> unprecedented business logic together with automation.
                </p>


              </div>
              <div className="w-2/2 flex items-center justify-start gap-3 mt-6">
                <Buttons onClick={() => clickHandler(redirecturls.learnmore)} btnText="Learn More" classN="pt-2 pb-2 w-32 rounded-md font-medium text-white bg-scogoOrange hover:border hover:border-scogoOrange hover:text-scogoOrange hover:bg-transparent" />
                <Buttons onClick={() => setpopup(true)} btnText="What We Do" Iconbefore={<PlayCircleOutlineIcon className='mr-2' />} classN=" pt-2 pb-2 w-36 rounded-md font-medium text-lightblue bg-transparent border border-lightblue hover:bg-scogoprimary hover:text-white" />
              </div>
            </div>
          </div>

        </div>


        {/* How Work Section */}
        <div >
          <div className="mt-24" >
            <div className="text-center">
              <h1 className="text-5xl font-bold text-lightblue" > <span className='text-scogoOrange'>How</span> It Works</h1>
            </div>
            <div className=" text-center w-1/2 m-auto mt-8 text-lg"  >
              <p>SuperApp offers a state-of-the-art technology platform that provides your business the ability to scale in today’s competitive landscape.</p>
            </div>
          </div>
          <div className="absolute w-full m-auto">
            <div className="w-11/12 bg-lightteal h-1 backgroundline  mt-12" >
            </div>
            <div className="w-11/12 grid grid-cols-5 text-center justify-center numbers mt-8" >
              <div> <p className=" w-9 m-auto p-1 border-2 rounded-full border-scogoOrange bg-white" >1</p></div>
              <div> <p className="w-9 m-auto p-1 border-2 rounded-full border-scogoOrange bg-white" >2</p></div>
              <div> <p className="  w-9 m-auto p-1 border-2 rounded-full border-scogoOrange bg-white" >3</p></div>
              <div> <p className="  w-9 m-auto p-1 border-2 rounded-full border-scogoOrange bg-white" >4</p></div>
              <div> <p className="  w-9 m-auto p-1 border-2 rounded-full border-scogoOrange bg-white" >5</p></div>
            </div>
            <div className="relative">
              <div className="w-11/12 grid grid-cols-5 m-auto gap-px text-center justify-center mt-10" >
                <HowWorkIcon img={imgIcon.BookRequest} iconFirstText="Book A" iconlastText="Request" />
                <HowWorkIcon img={imgIcon.Track} iconFirstText="Track " iconlastText="Status" />
                <HowWorkIcon img={imgIcon.Collaborate} iconFirstText="Collaborate With" iconlastText=" Field Teams" />
                <HowWorkIcon img={imgIcon.ApproveRate} iconFirstText="Approve & Rate " iconlastText="Performance" />
                <HowWorkIcon img={imgIcon.PayOnDemand} iconFirstText="PAY " iconlastText="On-Demand" />
              </div>
            </div>
          </div>


        </div>


        {/* Marketplace Section */}
        <div className="mt-96" ></div>
        <br />
        <div>
          <div className="mt-20 text-center">
            <h1 className="text-5xl font-bold text-lightblue" > <span className='text-scogoOrange'>Marketplace </span> of technicians</h1>
          </div>
          <div className=" text-center w-1/2 m-auto mt-8 text-lg"  >
            <p>Scogo Networks puts a marketplace of technicians at your fingertips and project management tools in your back pocket</p>
          </div>
          <div className="mt-16" >
            <div className="grid grid-cols-3 justify-items-center" >
              <MarketplaceCard Icon={<ShareIcon />} Iconheading="One place to manage everything" Subheading='“Everything we do is managed through Field Nation: materials, lists, shipping, everything… If it’s not in Field Nation, it didn’t happen."' Subname="Karen Quinn, Worldlink" />
              <MarketplaceCard Icon={<AlarmOnIcon />} Iconheading="Immediacy, consistency, and reliability" Subheading="“We can’t have a device down, and Field Nation allows us to respond within an hour if there is an issue. In our business, timeliness is everything- and Field Nation is always right on top of it.”" Subname="Angie Williams, VCPI" />
              <MarketplaceCard Icon={<ExploreIcon />} Iconheading="Finding quality technicians even in remote locations" Subheading="“Field Nation consistently helps us find workers in remote areas when we get stuck. Of the thousands of jobs we did last year through the Field Nation marketplace, we were able to find a technician 100% of the time.”" Subname="Tyler Jones, Survey Studio" />
            </div>
          </div>
        </div>


        {/* Commitment to Serve Section */}
        <div className=" growBusiness mt-24 pb-2" >
          <div className="flex m-auto items-center justify-center pt-10" >
            <div className="w-1/2 pl-28" >
              <div className="">
                <h1 className="font-bold text-scogoOrange text-5xl">Commitment to    <span className="mt-2 font-bold text-scogoprimary text-5xl"> Serve</span></h1>

                <p className="mt-8 text-lg w-11/12 h-40">Once a Service Request is booked, Scogo team ensures delivery as per your timelines & expectations..</p>


              </div>
              <div className="w-2/2 flex items-center justify-start gap-3 mt-6 cursor-pointer">
                <Buttons onClick={() => clickHandler(redirecturls.contactus)} btnText="Contact Us" classN="pt-2 pb-2 w-32 rounded-md font-medium text-white bg-scogoOrange border  hover:border-scogoOrange hover:text-scogoOrange hover:bg-transparent" />
              </div>
            </div>
            <div className="w-1/2 ">
              <div className="p-4 ">
                <img width="80%" className='m-auto' height="100%" src={imgIcon.Commitment} alt="" />
              </div>
            </div>
          </div>









        </div>


        {/*Why Scogo Is Your Ideal Service Partner  */}
        <div>
          <div className="mt-24 text-center">
            <h1 className="text-5xl font-bold text-lightblue " >Why  <span className='text-scogoOrange'>Scogo</span> Is Your Ideal <br /> Service Partner </h1>
          </div>
          <div className=" text-center w-1/2 m-auto mt-8 text-lg"  >
            <p>With SuperApp, you can focus on growing your business instead of <br /> worrying about how you'll find technicians</p>
          </div>
          <div className="grid grid-cols-3 gap-2 w-4/5 m-auto justify-items-center"  >
            <ServicePartnerCard heading="On-Demand Coverage Across India" Subname="Search from 100,000+ technicians to find qualified candidates with the right skillset for your project" />
            <ServicePartnerCard heading="IT Service Industries Supported- Exclusively" Subname="From ATMs to point-of-sale and data storage to networking, our marketplace of technicians can jump in at a moment’s notice." />
            <ServicePartnerCard heading="24/7/365 Customer Support by Your Side" Subname="Rely on our team of experts to answer all of your questions online over the phone." />

            <ServicePartnerCard heading="No Software to Download or Set-Up" Subname="Sign-up for a free account from your web browser and start creating work orders to connect with technicians immediately." />
            <ServicePartnerCard heading="Payments and Tax Documentation Handled" Subname="Once work orders are approved, we handle the rest. Scogo pays service providers twice weekly and issues 1099s." />
            <ServicePartnerCard heading="Integrations Keep Your Data in One Place" Subname="Scogo seamlessly integrates with the most popular CRM, ERP, and IT management solutions to improve efficiency and minimize data loss." />
          </div>

        </div>



        {/* Subscribe Our Newsletter */}

        <div className="mt-12 ">
          <div className="subscribeSection" >
            <div className="text-center">
              <h1 className="text-5xl font-bold text-lightblue" > <span className='text-scogoOrange'>Subscribe</span>  Our Newsletter</h1>
            </div>
            <div className=" text-center w-1/2 m-auto mt-8 text-lg"  >
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In cursus faucibus felis,</p>
            </div>
            <div>

              <div className='flex mt-8 items-center m-auto p-2 rounded-lg text-lightgray textCard bg-white' style={{ width: "30rem" }} >
                <EmailIcon />
                <input type="email" className="w-4/5 ml-3 text-lg" placeholder="Email" />
                <Buttons btnText="Subscribe" classN=" w-32 p-2 text-base rounded-lg text-white bg-scogoOrange" />
              </div>

            </div>

          </div>
        </div>

      </div>
      <Footer />
    </>
  )
}

export default Home
